<template>
  <div class="main-content" id="content">
    <h3 class="marginBottom20">
      {{ `${type === "add" ? "新增" : type === "edit" ? "编辑" : "查看"}内容` }}
    </h3>
    <!-- <el-card style="padding-left: 50px"> -->
    <el-form
      ref="form"
      :model="form"
      label-position="left"
      label-width="80px"
      :rules="rules"
    >
      <el-form-item label="内容标题" prop="title">
        <el-input
          v-model="form.title"
          placeholder="请输入"
          style="width: 400px"
          maxlength="50"
          :disabled="disabled"
        ></el-input>
      </el-form-item>

      <el-form-item label="内容分类" :span="8" prop="classifyId">
        <el-select
          v-model="form.classifyId"
          clearable
          style="width: 400px"
          :disabled="disabled"
        >
          <el-option
            v-for="item in classifyList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容" :span="8" prop="content">
        <FormEditor
          :details="form.content"
          @editoChange="editoChange"
          :disabled="disabled"
        />
      </el-form-item>

      <el-form-item>
        <el-button @click="revert">返回</el-button>
        <el-button type="primary" @click="submit" v-if="!disabled"
          >确认</el-button
        >
      </el-form-item>
    </el-form>
    <!-- </el-card> -->
  </div>
</template>

<script>
import {
  contentListClassify,
  contentManageAdd,
  contentManageUpdate,
  contentManageView,
} from "@/api/content/manage";
import FormEditor from "@/components/formComponents/formEditor";
import dayjs from "dayjs";
import FormFileUpload from "@/components/formComponents/formFileUpload";

export default {
  name: "create",
  components: {
    FormEditor,
    FormFileUpload,
  },
  data() {
    return {
      classifyList: [],
      id: this.$route.query.id,
      disabled: this.$route.query.type === "view",
      type: this.$route.query.type,
      form: {
        classifyId: "",
        content: "",
        title: "",
      },
      //校验规则
      rules: {
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        classifyId: [{ required: true, message: "请输入", trigger: "blur" }],
        content: [
          {
            required: true,
            message: "请输入权益内容",
            trigger: "blur",
          },
          {
            validator(_, value) {
              if (value) {
                if (value === "<p><br></p>") {
                  return Promise.reject(new Error("请输入内容"));
                }
                if (value.length > 65535) {
                  return Promise.reject(new Error("内容超出最大长度限制"));
                }
              }
              return Promise.resolve(true);
            },
          },
        ],
      },
      loadingSubmit: false,
    };
  },
  mounted() {
    this.getClassifyList();
    if (this.id) {
      this.getView();
    }
  },
  methods: {
    async getView() {
      if (this.id) {
        const { data } = await contentManageView(this.id);
        this.form = {
          ...data,
        };
      }
    },

    async submit() {
      if (this.loadingSubmit) {
        return;
      }
      let newVal = {
        ...this.form,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingSubmit = true;
          if (this.type == "add") {
            contentManageAdd({
              ...newVal,
            })
              .then((res) => {
                // 获取数据成功后的其他操作
                if (res.code == 200) {
                  this.loadingSubmit = false;
                  this.$router.go(-1);
                } else {
                  this.loadingSubmit = false;
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                // loading.close();
                // this.$message.error(err.msg);
                this.loadingSubmit = false;
              });
          } else {
            contentManageUpdate({
              ...newVal,
              id: this.id,
            })
              .then((res) => {
                // 获取数据成功后的其他操作
                if (res.code == 200) {
                  this.loadingSubmit = false;
                  this.$router.go(-1);
                } else {
                  this.loadingSubmit = false;
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                // loading.close();
                // this.$message.error(err.msg);
                this.loadingSubmit = false;
              });
          }
        }
      });
    },
    //富文本框变化替换值
    editoChange(e) {
      this.form.content = e;
    },
    //文件上传
    upload(e, name) {
      if (Array.isArray(e)) {
        this.form.firmwareUrl = [...e];
      } else {
        this.form.firmwareUrl = [...this.form.firmwareUrl, e];
      }
      this.form.firmwareName = name;
    },
    //图片上传
    uploadImg(e) {
      if (Array.isArray(e)) {
        this.form.mainImage = [...e];
      } else {
        this.form.mainImage = [...this.form.mainImage, e];
      }
    },
    //权益分类
    getClassifyList() {
      contentListClassify({}).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.classifyList = res.data;
        }
      });
    },
    revert() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.main-content {
  padding-left: 30px;
  padding-right: 40%;
}
</style>
